// extracted by mini-css-extract-plugin
module.exports = {"customTooltip":"styles__customTooltip___2KWWz","lg":"styles__lg___Vgid9","sm":"styles__sm___3-oXF"};